namespace SPA {
	export namespace Contacts {
		export class List extends ui.tab.TabHTMLPresentation
		{
			private Company: Wollmilch.CompanyObject;
			private ContactList: SPA.Contacts.ContactList;
			private Table: JQuery;
			private addressTypes: { [key: string]: any };
			private Events: Backbone.Events;

			public constructor(company: Wollmilch.CompanyObject) {
				super();

				this.Company = company;
				this.ContactList = app.getContactManager().getContacts();
				this.Table = $('<table class="table table-striped table-condensed table-hover">');
				this.addressTypes = {};
				this.Events = Backbone.Events;

				this.Events.listenTo(this.ContactList, 'add', (contact: SPA.Contact) => {
					this.Table.DataTable().row.add(contact).draw();
				});
				this.Events.listenTo(this.ContactList, 'change remove', (contact: Contact, changeOptions: any) =>
				{
					this.Table.DataTable().row('#' + contact.ContactID).data(contact).draw();
				});
			}

			public rebuild(root: ui.base.BaseHTMLElement<HTMLElement> | JQuery<HTMLElement>)
			{
				root.empty();

				const contactBox = new ui.Box.Box(false, {id: 'RealtorContacts'});
				//contactBox.addTitle('Kontaktverwaltung');
				contactBox.rebuild(root);
				contactBox.append(ui.$$.h(2, [$('<span>Adressbuch</span>')]).addClass('segment'));

				this.buildContent(contactBox);

				return this;
			}

			private buildContent(root: ui.base.BaseHTMLElement): void {

				const btnNewContact = $('<button class="btn btn-primary" id="addressNew" type="button"><i class="fa fa-plus-circle"></i> Neuen Kontakt anlegen</button>')
					.on('click', (e) => {
					const contactModal = new SPA.Contacts.Modal(this.Company);
					// Set modal title
					contactModal.setTitle('Neuen Kontakt anlegen');
					// Build and append the new "customer" form
					contactModal.setType('contact');
					contactModal.setPrimaryButtonText('Anlegen');
					// show the form
					contactModal.show();
				});

				const addressSearch = $('<input class="form-control" type="text" name="address.search" data-type="all" placeholder="Adressbuch durchsuchen">');

				const content =
					ui.$$.div().addClass('row')
						.append(ui.$$.div().addClass('col-xs-6')
							.append(addressSearch)
						)
						.append(ui.$$.div().addClass('col-xs-6')
							.append(btnNewContact)
						);

				this.Table
					.append($('<thead>').append($('<tr>')
						.append('<th>KdNr</th>')
						.append('<th style="min-width: 82px;">angelegt am</th>')
						.append('<th>Zuordnung(en)</th>')
						.append('<th>Kontakt</th>')
						.append('<th>Anschrift</th>')
						.append('<th>E-Mail</th>')
						.append('<th>Mobil</th>')
						.append('<th>Telefon</th>')
						.append('<th>Aktion</th>')
					))
					.css({
						'table-layout': 'fixed',
						'width': '100%'
					})
					.append($('<tbody>'))
					.on('click', 'tr td', (e: JQuery.Event) => this.onContactRowClick(e))
					.DataTable({
						paging: true,
						searching: true,
						order: [[1, "desc"]],
						columnDefs: [
							{targets: [0, 1], searchable: false},
							{targets: [0], visible: false},
							{
								targets: -1,
								render: (data, type, row, meta) => {
									const contact: SPA.Contact = row;
									// TODO: implement delete function
									// if (contact.isEmptyStatus() && contact.isExclusiveBidder()) {
									// 	return '<button type="button contact-delete" class="btn btn-link btn-sm btn-link-danger"><i class="fas fa-trash"></i> Löschen</button>';
									// } else {
									// 	return ' &ndash;';
									// }
									return ' &ndash;';
								}
							}
						],
						data: this.ContactList.models,
						rowId: 'ContactID',
						columns: [
							{data: 'ContactID'},
							{data: {_: 'createDate', sort: 'createTimestamp'}},
							{data: 'statusList'},
							{data: 'completeName'},
							{data: 'completeAddress'},
							{data: 'Email'},
							{data: 'Mobile'},
							{data: 'Phone'},
							{data: 'isExclusiveBidder'}
						]
					});
				root.append(content.add(this.Table));

				addressSearch.on('keyup', (e) => {
					const search = $(e.currentTarget).val();

					if (search !== undefined)
					{
						this.Table.DataTable().search(search.toString()).draw();
					}
				});
			}

			private onContactRowClick(e: JQuery.TriggeredEvent)
			{
				const contact = (this.Table.DataTable().row(e.currentTarget.parentNode).data() as SPA.Contact);
				const isExclusiveBidder: boolean = this.Table.DataTable().cell(e.currentTarget).data();

				if (isExclusiveBidder === true)
				{
					if (confirm('Möchten Sie diesen Kaufinteressenten bei allen zugerdoneten Objekten und die eingegebenen Daten wirklich unwiderruflich löschen?'))
					{
						// TODO: Implement delete function
						// app.getContactManager().deleteStatus(contact,  'bidder');
					}
					return;
				}
				app.getGlobalTabControl().addTab(
					contact.Surname + ', ' + contact.Name + ' (' + contact.ContactID + ')',
					new SPA.Contacts.Detail(contact),
					true
				);
			}
		}
	}
}
